export default "__VITE_PUBLIC_ASSET__78aed395__"